import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "#777E91", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.91 7.265a1 1 0 0 0-1.414.057l-3.23 3.5a1 1 0 0 0 0 1.356l3.23 3.5a1 1 0 0 0 1.47-1.356L8.284 12.5H18a1 1 0 1 0 0-2H8.284l1.682-1.822a1 1 0 0 0-.057-1.413Z", fill: "currentColor", opacity: 0.6 }));
const ForwardRef = forwardRef(SvgIconArrowLeft);
export default ForwardRef;
